(() => {

  const INSTANCES = (window.HS_MODAL_CFG || []).map(cfg => {
    const modal   = document.getElementById(`hs-modal-${cfg.sectionId}`);
    const openBtn = document.getElementById(`hs-open-modal-${cfg.sectionId}`);
    const closeBtn= document.getElementById(`hs-close-modal-${cfg.sectionId}`);
    const mount   = document.getElementById(cfg.formMountId);

  const portalId = modal?.dataset.hsPortal  || openBtn?.dataset.hsPortal;
  const region   = modal?.dataset.hsRegion  || openBtn?.dataset.hsRegion || 'na1';
  const formId   = modal?.dataset.hsFormId  || openBtn?.dataset.hsFormId;

    return { sectionId: cfg.sectionId, modal, openBtn, closeBtn, mount, portalId, region, formId };
  }).filter(i => i.modal && i.openBtn && i.mount && i.portalId && i.formId);

  if (!INSTANCES.length) return;

  const UTM_COOKIE = 'goe_ga_utms';
  const COOKIE_DOMAIN = undefined; 

  const allowedUtms = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'];

  function setCookie(name, value, days = 1, domain) {
    const exp = new Date(Date.now() + days * 864e5).toUTCString();
    const dom = domain ? `; domain=${domain}` : '';
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${exp}; path=/${dom}`;
  }
  function getCookie(name) {
    const m = document.cookie.split('; ').find(x => x.startsWith(name + '='));
    return m ? decodeURIComponent(m.split('=')[1]) : null;
  }
  function removeCookie(name, domain) {
    const dom = domain ? `; domain=${domain}` : '';
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${dom}`;
  }
  function readUrlUtms() {
    const out = {};
    const params = new URLSearchParams(location.search);
    params.forEach((val, key) => {
      if (allowedUtms.includes(key) && val) out[key] = val;
    });
    return out;
  }
  function persistUrlUtmsToCookie() {
    const urlUtms = readUrlUtms();
    if (Object.keys(urlUtms).length) {
      setCookie(UTM_COOKIE, JSON.stringify(urlUtms), 1, COOKIE_DOMAIN);
    }
  }
  function readCookieUtms() {
    const txt = getCookie(UTM_COOKIE);
    if (!txt) return {};
    try { return JSON.parse(txt) || {}; } catch { return {}; }
  }
  function resolveUtms() {
    const c = readCookieUtms();
    const u = readUrlUtms();
    return { ...c, ...u };
  }
  persistUrlUtmsToCookie();

  async function getProductContext() {
    try {
      const handle = location.pathname.split('/products/')[1]?.split('/')[0];
      if (!handle) return { productTitle: null, sku: null };
      const p = await (await fetch(`/products/${handle}.js`, { cache: 'no-store' })).json();
      const ids = p.variants.map(v => v.id);
      const urlVid = Number(new URLSearchParams(location.search).get('variant'));
      let selectedId = ids.includes(urlVid) ? urlVid : null;
      if (!selectedId) {
        const analyticsVid = window.ShopifyAnalytics?.meta?.selectedVariantId;
        if (ids.includes(analyticsVid)) selectedId = analyticsVid;
      }
      if (!selectedId) {
        selectedId = (p.variants.find(v => v.available) || p.variants[0])?.id || null;
      }
      const variant = selectedId
        ? await (await fetch(`/variants/${selectedId}.js`, { cache: 'no-store' })).json()
        : null;
      return {
        productTitle: p?.title ?? null,
        sku: variant?.sku ?? (p?.variants?.find(v => v.id === selectedId)?.sku ?? null)
      };
    } catch (e) {
      console.warn('getProductContext error', e);
      return { productTitle: null, sku: null };
    }
  }

  function setHiddenInput(formEl, name, value) {
    if (!formEl) return;
    let input = formEl.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.className = 'hs-input';
      formEl.appendChild(input);
    }
    input.value = value ?? '';
  }

  function ensureHsScript(cb) {
    if (window.hbspt?.forms) return cb();
    if (document.getElementById('hs-embed-src')) {
      const check = setInterval(() => {
        if (window.hbspt?.forms) { clearInterval(check); cb(); }
      }, 100);
      return;
    }
    const s = document.createElement('script');
    s.id = 'hs-embed-src';
    s.src = 'https://js.hsforms.net/forms/embed/v2.js';
    s.async = true;
    s.onload = cb;
    document.head.appendChild(s);
  }

  function mountHubspotForm(inst) {
    if (!window.hbspt?.forms) return;
    if (inst._loaded) return;

    window.hbspt.forms.create({
      region: inst.region,
      portalId: inst.portalId,
      formId: inst.formId,
      target: `#hs-form-mount-${inst.sectionId}`,

      onFormReady: async function ($form) {
        const formEl = ($form && $form[0]) ? $form[0]
                     : ($form && $form.nodeType === 1) ? $form
                     : inst.mount.querySelector('form');

        if (formEl) formEl.querySelectorAll('input[name^="utm_"]').forEach(inp => inp.value = '');
        const utms = resolveUtms();
        Object.keys(utms).forEach(k => {
          if (allowedUtms.includes(k)) setHiddenInput(formEl, k, utms[k]);
        });

        const { productTitle, sku } = await getProductContext();
        setHiddenInput(formEl, 'product_title', productTitle);
        setHiddenInput(formEl, 'sku', sku);

        const updateOnVariantChange = async () => {
          const ctx = await getProductContext();
          setHiddenInput(formEl, 'product_title', ctx.productTitle);
          setHiddenInput(formEl, 'sku', ctx.sku);
        };
        document.addEventListener('change', e => {
          const t = e.target;
          if (t && (t.name === 'id' || t.matches('[data-variant-selector], select[name^="options["]')))
            updateOnVariantChange();
        }, { passive: true });
         },
    onFormSubmitted: function () {
      removeCookie(UTM_COOKIE, COOKIE_DOMAIN);
    }
      
    });

    inst._loaded = true;
  }

  INSTANCES.forEach(inst => {
    const dialog = inst.modal?.querySelector('.hs-modal__dialog');

    function openModal(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      inst.modal.classList.add('is-open');
      document.body.classList.add('hs-no-scroll');
      if (dialog) dialog.focus();
      ensureHsScript(() => mountHubspotForm(inst));
    }
    function closeModal() {
      inst.modal.classList.remove('is-open');
      document.body.classList.remove('hs-no-scroll');
      if (inst.openBtn) inst.openBtn.focus();
    }

    inst.openBtn?.addEventListener('click', openModal);
    inst.closeBtn?.addEventListener('click', closeModal);
    inst.modal?.addEventListener('click', (e) => { if (e.target === inst.modal) closeModal(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && inst.modal?.classList.contains('is-open')) closeModal();
    });
  });

  window.addEventListener('hs-form-event:on-submission:success', () => {
    removeCookie(UTM_COOKIE, COOKIE_DOMAIN);
  }, false);
})();
